import Vue from 'vue'
import Vuex from 'vuex'
import advertorials from './store/modules/advertorials'
import articles from './store/modules/articles'
import confirmation from './store/modules/confirmation'
import emailseries from './store/modules/emailseries'
import nextsteps from './store/modules/nextsteps'
import orders from './store/modules/orders'
import posts from './store/modules/posts'
import simplepage from './store/modules/simplepage'
import signup from './store/modules/signup'
import site from './store/modules/site'
import transcript from './store/modules/transcripts'
import vsl from './store/modules/vsls'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  modules: {
    advertorials,
    articles,
    confirmation,
    emailseries,
    nextsteps,
    orders,
    posts,
    simplepage,
    signup,
    site,
    transcript,
    vsl,
  }
})
